import axiosInstance from './axios';

export interface PersonalInfoPayload {
  firstName: string;
  lastName: string;
  /** ISO date, `YYYY-MM-DD`. */
  dateOfBirth: string;
  country: string;
  state: string;
  city: string;
  postalCode: string;
  streetAddress: string;
}

export const kycService = {
  getPersonalInfo: async (): Promise<PersonalInfoPayload | null> => {
    const response = await axiosInstance.get('/client/profile');
    return response.data?.data?.profile ?? null;
  },

  submitPersonalInfo: async (payload: PersonalInfoPayload) => {
    const response = await axiosInstance.patch('/client/profile', payload);
    return response.data;
  },
};
